import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { updateUygunaKiralaLocationSaga } from "src/store/uygunakirala-locations/saga";
import { UygunaKiralaLocationDetailDto } from "src/store/uygunakirala-locations/type";
import * as Yup from "yup";

const UygunaKiralaLocationEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: UygunaKiralaLocationDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("UygunaKiralaLocation.EditFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          Name: data.Name,
          Code: data.Code,
          Lat: data.Lat,
          Long: data.Long,
          Translates: data.Translates.map((x) => {
            return { LanguageId: x.LanguageId, Name: x.Name };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            updateUygunaKiralaLocationSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              id: data.Id,
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          Name: Yup.string().required(t("Validation.Required").toString()),
          Code: Yup.string().required(t("Validation.Required").toString()),
          Translates: Yup.array(
            Yup.object({
              Name: Yup.string().required(t("Validation.Required").toString()),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "Name",
            label: t("UygunaKiralaLocation.Name").toString(),
          },
        ]}
        inputs={[
          {
            field: "Code",
            label: t("UygunaKiralaLocation.Code").toString(),
          },
          {
            field: "Latitude",
            googlemap: {
              latField: "Latitude",
              lonField: "Longitude",
            },
          },
        ]}
      />
    </React.Fragment>
  );
};
export default UygunaKiralaLocationEditForm;
